<!-- 销售订单 -->
<template>
  <div>
    <el-row ref="searchBox" class="search-box">
      <el-col :span="4">
        <el-input v-model="condition.orderSn" clearable placeholder="请输入销售订单号" />
      </el-col>
      <el-col :span="4">
        <el-input v-model="condition.sapSalesOrderSn" clearable placeholder="请输入SAP销售订单号" />
      </el-col>
      <el-col :span="4">
        <el-select v-model="condition.status" placeholder="请选择订单状态">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="condition.deliveryType" placeholder="请选择单据类型">
          <el-option v-for="item in salesTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" icon="el-icon-search" @click="getPage('refresh')">查询</el-button>
        <el-button type="primary" @click="handleEdit(null)">新增</el-button>
      </el-col>
    </el-row>
    <el-table ref="listTable" v-loading="loading" :data="tableData" :height="tableHeight" border>
      <!-- <el-table-column type="selection" width="55" /> -->
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column label="订单状态" align="left" prop="status" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">制单</span>
          <span v-if="scope.row.status == 2">发货中</span>
          <span v-if="scope.row.status == 3">发货完成</span>
        </template>
      </el-table-column>
      <el-table-column label="单据类型" align="left" prop="deliveryType" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.deliveryType == 1">发货单</span>
          <span v-if="scope.row.deliveryType == 2">退货发货单</span>
          <span v-if="scope.row.deliveryType == 3">不定价发货单</span>
        </template>
      </el-table-column>
      <el-table-column label="交货单号" align="left" prop="sn" show-overflow-tooltip width="130" />
      <el-table-column label="SAP交货单号" align="left" prop="sapDeliverySn" width="130" show-overflow-tooltip />
      <el-table-column label="SAP调仓单号" align="left" prop="sapTransferOrder" width="130" show-overflow-tooltip />
      <el-table-column label="销售订单号" align="left" prop="orderSn" show-overflow-tooltip width="130" />
      <el-table-column label="SAP销售单号" align="left" prop="sapSalesOrderSn" width="130" show-overflow-tooltip />
      <!-- <el-table-column
        label="销售组织"
        align="left"
        prop="salesOrganizationName"
        show-overflow-tooltip
        width="150"
      /> -->
      <el-table-column label="售达方代码" align="left" prop="soldToPartyCode" width="130" show-overflow-tooltip />
      <el-table-column label="售达方" align="left" prop="soldToPartyName" width="130" show-overflow-tooltip />
      <el-table-column label="送达方代码" align="left" prop="deliverySideCode" width="130" show-overflow-tooltip />
      <el-table-column label="送达方" align="left" prop="deliverySideName" width="130" show-overflow-tooltip />
      <!-- <el-table-column
        label="交货状态"
        align="left"
        prop=""
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span v-if="scope.row.deliverType == 2">已交货</span>
          <span v-else>未交货</span>

        </template>

      </el-table-column> -->

      <!-- <el-table-column
        label="备注"
        align="left"
        prop="note"
        show-overflow-tooltip
      /> -->
      <!-- <el-table-column
        label="创建人"
        align="left"
        prop="createUser"
        show-overflow-tooltip
      /> -->
      <el-table-column label="调拨日期" align="left" prop="transferDate" width="180" show-overflow-tooltip />
      <el-table-column label="实际发货日期" align="left" prop="actualShippingTime" width="180" show-overflow-tooltip />
      <el-table-column label="创建时间" align="left" prop="createTime" width="180" show-overflow-tooltip />
      <el-table-column label="操作" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button v-if="scope.row.status<=2" type="text" @click="handleEdit(scope.row.id, '修改')">修改</el-button>
          <el-button type="text" @click="handleEdit(scope.row.id, '查看')">查看</el-button>
          <el-button v-if="scope.row.sapDeliverySn" type="text" @click="print(scope.row.id)">
            打印
          </el-button>
          <el-button v-if="scope.row.status<=1" type="text" @click="handleDelete(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.status===3" v-permission="'deliver:salesOrder:index:del'" type="text" @click="handleDelete(scope.row.id)">删除</el-button>

        </template>
      </el-table-column>
    </el-table>

    <el-row class="footer-box">
      <el-col :span="12" />
      <el-col :span="12">
        <pagination :total="pagination.total" :page.sync="pagination.current" :limit.sync="pagination.size" @pagination="getPage" />
      </el-col>
    </el-row>

    <edit ref="edit" :show="showEdit" :edit-id="editId" @close="closeEdit" />
  </div>
</template>

<script>
import { getPage, deleteById, get } from '@/api/crm/deliver/deliveryNote'
import Pagination from '@/components/Pagination'
import edit from './edit'
import deliveryNote from '@/utils/printJson/deliveryNote'
import { downloadFile } from '@/utils/file'
import json from 'highlight.js/lib/languages/json'
export default {
  name: 'CustomerAlterIndex',
  components: { Pagination, edit },
  data() {
    return {
      tableHeight: window.innerHeight - 200,
      showEdit: false,
      loading: false,
      editId: null,
      pagination: {
        total: 0,
        size: 20,
        current: 1
      },
      condition: {},
      tableData: [],
      statusOptions: [{ value: 1, label: '制单' }, { value: 3, label: '发货完成' }],
      salesTypeOptions: [{ value: 1, label: '发货单' }, { value: 2, label: '退货发货单' }, { value: 3, label: '不定价发货单' }]
    }
  },
  watch: {
    $route() {
      this.getPage()
    }
  },
  created() {
    this.getPage()
  },
  methods: {
    handleEdit(id, type) {
      this.showEdit = true
      this.editId = id
      this.$refs.edit.type = type
    },
    getPage(type) {
      this.loading = true
      if (type == 'refresh') {
        this.pagination.current = 1
      }
      // if (!this.condition.date) {
      //   this.condition.date = []
      // }
      getPage(this.condition, this.pagination)
        .then((reponse) => {
          const { current, total, size, records } = reponse.data
          this.tableData = records
          this.pagination.total = total
          this.pagination.current = current
          this.pagination.size = size
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleDelete(id) {
      this.$confirm('请确认是否删除此数据', '提示', { type: 'warning' }).then(
        () => {
          deleteById(id).then((response) => {
            this.$message.success('删除成功')
            this.getPage()
          })
        }
      )
    },
    handleConditionExport() {
      exportExcel(this.condition, this.pagination).then((response) => {
        downloadFile(response)
      })
    },
    closeEdit() {
      this.showEdit = false
      this.getPage()
    },
    async print(id) {
      const response = await get(id)
      const { data } = response
      data.middleCompanyName = data.middleCompanyName == null ? data.soldToPartyName : data.middleCompanyName
      data.deliveryType = data.deliveryType == 2 ? '退货单' : '出库单'

      this.$pluginName.init()
      for (let i = 0; i < data.deliveryOrdersListVos.length; i++) {
        data.deliveryOrdersListVos[i].weight = Number(data.deliveryOrdersListVos[i].deliveryQty * data.deliveryOrdersListVos[i].weight)
      }
      const count = data.deliveryOrdersListVos.length >= 30 ? 30 : data.deliveryOrdersListVos.length
      const num = 15
      deliveryNote.panels[0].paperFooter = 300 + (num * count)
      deliveryNote.panels[0].printElements[18].options.top = 305 + (num * count)
      deliveryNote.panels[0].printElements[17].options.top = 305 + (num * count)
      deliveryNote.panels[0].printElements[16].options.top = 305 + (num * count)
      deliveryNote.panels[0].printElements[15].options.top = 305 + (num * count)
      deliveryNote.panels[0].printElements[14].options.top = 305 + (num * count)

      var hiprintTemplate = new this.$pluginName.PrintTemplate(
        {
          template: deliveryNote,
          settingContainer: '#PrintElementOptionSetting',
          paginationContainer: '.hiprint-printPagination'
        }
      )

      console.log(hiprintTemplate)
      // eslint-disable-next-line no-undef
      console.log(data.deliveryOrdersListVos)

      if (data.deliveryOrdersListVos && data.deliveryOrdersListVos.length > 0) {
        const ZP03Arr = data.deliveryOrdersListVos.filter(u => u.productType === 1 && u.productCode.length === 6)
        let ZP03Num = 0
        for (const v of ZP03Arr) {
          ZP03Num = ZP03Num + v.deliveryQty
        }
        const lastZP03Index = data.deliveryOrdersListVos.findLastIndex(u => u.productType === 1 && u.productCode.length === 6)
        const ZP03Weight = Math.floor((data.allWeight / ZP03Num) * 100) / 100
        console.log(ZP03Num, lastZP03Index, ZP03Weight)

        let ZP03WeightAll = 0
        for (const item of data.deliveryOrdersListVos) {
          if (item.productType === 1 && item.productCode.length === 6) {
            item.weight = Math.floor(ZP03Weight * item.deliveryQty * 100) / 100
            ZP03WeightAll = Math.floor((ZP03WeightAll + item.weight) * 100) / 100
          } else if (item.productType === 2) {
            item.weight = item.deliveryQty
          }
        }

        console.log('ZP03WeightAll', ZP03WeightAll)
        // 尾余 最后一条zp03的重量等于 总重量-之前分配的总量
        if (lastZP03Index !== -1) {
          const count = data.deliveryOrdersListVos[lastZP03Index].weight
          console.log('count', count)
          console.log(data.allWeight, ZP03WeightAll - count, data.allWeight * 100 - (ZP03WeightAll - count) * 100)
          data.deliveryOrdersListVos[lastZP03Index].weight = Math.floor((data.allWeight * 100 - (ZP03WeightAll - count) * 100)) / 100
          console.log(data.deliveryOrdersListVos[lastZP03Index].weight)
        }
      }

      // debugger
      hiprintTemplate.print(data, {}, {
        callback: () => {
          console.log('浏览器打印窗口已打开')
        }
      })
    }
  }
}
</script>

    <style scoped>
.el-table >>> .el-table__fixed-body-wrapper {
  top: 30px !important;
}
</style>

